import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["colorList", "colorRow", "addButton", "template", "remainingCount", "colorPicker", "hexInput"]
  static values = { maxColors: { type: Number, default: 10 } }

  connect() {
    this.updateButtonState()
  }

  addColor() {
    if (this.colorRowTargets.length >= this.maxColorsValue) {
      return
    }

    const template = this.templateTarget.innerHTML
    const newIndex = Date.now()
    const newRow = template.replace(/INDEX/g, newIndex)

    this.colorListTarget.insertAdjacentHTML('beforeend', newRow)
    this.updateButtonState()

    // Focus the new color name input
    const newRowElement = this.colorListTarget.lastElementChild
    const nameInput = newRowElement.querySelector('input[type="text"]')
    if (nameInput) {
      nameInput.focus()
    }
  }

  removeColor(event) {
    // Prevent removing if only one color remains
    if (this.colorRowTargets.length <= 1) {
      return
    }

    const row = event.currentTarget.closest('[data-color-palette-editor-target="colorRow"]')
    if (row) {
      row.remove()
      this.updateButtonState()
    }
  }

  updateHexFromPicker(event) {
    const picker = event.currentTarget
    const row = picker.closest('[data-color-palette-editor-target="colorRow"]')
    const hexInput = row.querySelector('[data-color-palette-editor-target="hexInput"]')

    if (hexInput) {
      hexInput.value = picker.value.toUpperCase()
    }
  }

  updatePickerFromHex(event) {
    const hexInput = event.currentTarget
    const row = hexInput.closest('[data-color-palette-editor-target="colorRow"]')
    const picker = row.querySelector('[data-color-palette-editor-target="colorPicker"]')

    let hex = hexInput.value.trim()

    // Normalize hex value
    if (!hex.startsWith('#')) {
      hex = '#' + hex
    }

    // Convert 3-char hex to 6-char
    if (/^#[A-Fa-f0-9]{3}$/.test(hex)) {
      hex = '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3]
    }

    // Only update picker if valid 6-char hex
    if (/^#[A-Fa-f0-9]{6}$/.test(hex) && picker) {
      picker.value = hex
    }
  }

  updateButtonState() {
    const currentCount = this.colorRowTargets.length
    const remaining = this.maxColorsValue - currentCount

    if (this.hasAddButtonTarget) {
      if (currentCount >= this.maxColorsValue) {
        this.addButtonTarget.disabled = true
        this.addButtonTarget.classList.add('opacity-50', 'cursor-not-allowed')
      } else {
        this.addButtonTarget.disabled = false
        this.addButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed')
      }
    }

    if (this.hasRemainingCountTarget) {
      this.remainingCountTarget.textContent = `${currentCount}/${this.maxColorsValue}`
    }
  }
}
